<template>
    <div v-if="jackpot">
        <!-- name -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Name</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input
                            v-model="jackpot.name"
                            :class="[{ 'is-danger': !$v.jackpot.name }, 'input', 'oc-input']"
                            type="text"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- is shared -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Is shared</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input type="checkbox" v-model="jackpot.sharedSettings.enabled">
                    </div>
                </div>
            </div>
        </div>

        <!-- shared bet ttl -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Shared bet ttl</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <input
                            v-model="jackpot.sharedSettings.betTtl"
                            class="input oc-input"
                            type="text"
                            :disabled="!jackpot.sharedSettings.enabled"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- skin -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Skin</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select">
                            <select v-model="jackpot.skin">
                                <option>bronze</option>
                                <option>silver</option>
                                <option>gold</option>
                                <option>platinum</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- currency -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Currency</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div
                            :class="[{ 'is-danger': $v.jackpot.currency.$invalid }, 'select', 'oc-input']"
                        >
                            <select v-model="jackpot.currency">
                                <option
                                    v-for="c in currencies"
                                    :key="c.id"
                                    :value="c.id"
                                >{{c.id}} {{c.symbol}} ({{c.description}})</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- series length -->
        <div v-if="jackpotType == 'series'" class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Series length</label>
            </div>
            <div class="field-body">
                <div class="field" :class="{'has-addons': !seriesLength}">
                    <div class="control">
                        <input v-model="seriesLength" class="input oc-input" type="number" />
                    </div>
                    <p v-if="!seriesLength" class="control">
                        <a class="button is-static has-text-danger">infinite</a>
                    </p>
                </div>
            </div>
        </div>

        <!-- start amount -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Start Amount</label>
            </div>
            <div class="field-body">
                <div class="field has-addons">
                    <p class="control">
                        <currency-input
                            :value="jackpot.state.amountStart"
                            :currency="currency"
                            :set="(val) => jackpot.state.amountStart = val"
                            :class="[{ 'is-danger': $v.jackpot.state.amountStart.$invalid }, 'input', 'oc-input']"
                        />
                    </p>
                    <p class="control">
                        <a class="button is-static">{{ currency }}</a>
                    </p>
                </div>
            </div>
        </div>

        <!-- limit -->
        <p class="title is-5">Limit Settings</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Min Amount</label>
            </div>
            <div class="field-body">
                <div class="field has-addons">
                    <p class="control">
                        <currency-input
                            :value="jackpot.limitSettings.amountMin"
                            :currency="currency"
                            :set="(val) => jackpot.limitSettings.amountMin = val"
                            :class="[{ 'is-danger': !$v.jackpot.limitSettings || $v.jackpot.limitSettings.amountMin.$invalid }, 'input', 'oc-input']"
                        />
                    </p>
                    <p class="control">
                        <a class="button is-static">{{ currency }}</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Max Amount</label>
            </div>
            <div class="field-body">
                <div class="field has-addons">
                    <p class="control">
                        <currency-input
                            :value="jackpot.limitSettings.amountMax"
                            :currency="currency"
                            :set="(val) => jackpot.limitSettings.amountMax = val"
                            :class="[{ 'is-danger': !$v.jackpot.limitSettings || $v.jackpot.limitSettings.amountMax.$invalid }, 'input', 'oc-input']"
                        />
                    </p>
                    <p class="control">
                        <a class="button is-static">{{ currency }}</a>
                    </p>
                </div>
            </div>
        </div>

        <!-- charge -->
        <p class="title is-5">Charge Settings</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Stake Percent Current</label>
            </div>
            <div class="field-body">
                <div class="field has-addons">
                    <p class="control">
                        <input
                            v-model="jackpot.chargeSettings.stakePercentCurrent"
                            :class="[{ 'is-danger': !$v.jackpot.chargeSettings || $v.jackpot.chargeSettings.stakePercentCurrent.$invalid }, 'input', 'oc-input']"
                            type="number"
                        />
                    </p>
                    <p class="control">
                        <a class="button is-static">%</a>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Stake Percent Next</label>
            </div>
            <div class="field-body">
                <div class="field has-addons">
                    <p class="control">
                        <input
                            v-model="jackpot.chargeSettings.stakePercentNext"
                            :class="[{ 'is-danger': !$v.jackpot.chargeSettings || $v.jackpot.chargeSettings.stakePercentNext.$invalid }, 'input', 'oc-input']"
                            type="number"
                        />
                    </p>
                    <p class="control">
                        <a class="button is-static">%</a>
                    </p>
                </div>
            </div>
        </div>

        <!-- trigger -->
        <p class="title is-5">Trigger Settings</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Min Stake</label>
            </div>
            <div class="field-body">
                <div class="field has-addons">
                    <p class="control">
                        <currency-input
                            :value="jackpot.triggerSettings.stakeMin"
                            :currency="currency"
                            :set="(val) => jackpot.triggerSettings.stakeMin = val"
                            :class="[{ 'is-danger': !$v.jackpot.triggerSettings || $v.jackpot.triggerSettings.stakeMin.$invalid }, 'input', 'oc-input']"
                        />
                    </p>
                    <p class="control">
                        <a class="button is-static">{{ currency }}</a>
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button
                            :disabled="$v.$invalid"
                            class="button is-primary"
                            @click="save();"
                        >Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import state from '../../../../../../state';

import { required, minValue } from 'vuelidate/lib/validators';

import currencyService from '../../../../../../services/currency.service';
import jackpotService from '../../../../../../services/jackpot.service';
import notyService from '../../../../../../services/noty.service';

import CurrencyInput from '../../../../../common/currency-input.vue';

export default {
    name: 'branch-jackpot-create',
    components: { CurrencyInput },
    data: () => ({
        jackpot: null,
        monitorHost: null
    }),
    computed: {
        jackpotType: function() {
            return this.$route.params.type;
        },
        branch: function() {
            return this.$route.params.branch;
        },
        clientId: function() {
            return Number(this.$route.params.clientId) || null;
        },
        currencies: function() {
            return state.currencies.get();
        },
        currency: function() {
            return this.jackpot && this.jackpot.currency;
        },
        seriesLength: {
            get() {
                if (!this.jackpot.series.seriesLength || this.jackpot.series.seriesLength <= 0) this.jackpot.series.seriesLength = null;
                return this.jackpot.series.seriesLength;
            },
            set(value) {
                if (!value || value <= 0) this.jackpot.series.seriesLength = null;
                this.jackpot.series.seriesLength = value;
            }
        }
    },
    validations: {
        jackpot: {
            name: { required },
            currency: { required },
            state: {
                amountStart: {
                    required,
                    minValue: minValue(0.01)
                }
            },
            limitSettings: {
                amountMin: {
                    required,
                    minValue: minValue(0.01)
                },
                amountMax: {
                    required,
                    minValue: minValue(0.01)
                }
            },
            chargeSettings: {
                stakePercentCurrent: {
                    required,
                    minValue: minValue(0.0001)
                },
                stakePercentNext: {
                    required,
                    minValue: minValue(0)
                }
            },
            triggerSettings: {
                stakeMin: {
                    required,
                    minValue: minValue(0)
                }
            }
        }
    },
    async created() {
        await this.loadJackpot();
    },
    methods: {
        async loadJackpot() {
            this.jackpot = await jackpotService.getJackpotTemplate(this.clientId, this.branchName);
        },
        async save() {
            this.branch && (this.jackpot.branch = this.branch);
            this.clientId && (this.jackpot.clientId = this.clientId);
            this.jackpot =
                this.jackpotType == 'single'
                    ? await jackpotService.createSingleJackpot(this.jackpot)
                    : await jackpotService.createSeriesJackpot(this.jackpot);
            notyService.success(`Jackpot '${this.jackpot.number}' created successfully`);
            this.$router.push({ name: 'branch-jackpots' });
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/branch/jackpots/create.vue